import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetSettingsControlBase } from '../control-base';
import { isDefined } from '@fi-shared/utils/is-defined';

@Component({
    selector: 'widget-settings-control-news-feed',
    templateUrl: './news-feed.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class WidgetSettingsControlNewsFeedComponent extends WidgetSettingsControlBase implements OnInit {
    ngOnInit(): void {
        if (!isDefined(this.Settings.ShowForumActivity)) {
            this.Settings.ShowForumActivity = true;
        }
    }
}
